/** Shared file type constants for document uploads across the system. */

/** Allowed file extensions for the file input accept attribute */
export const ALLOWED_EXTENSIONS =
  '.jpg,.jpeg,.png,.gif,.svg,.tiff,.tif,.bmp,.webp,.heic,.heif,.pdf,.doc,.docx,.xls,.xlsx,.rtf,.csv,.txt,.html,.wav';

/** Maximum upload file size in bytes (10MB) */
export const MAX_FILE_SIZE = 10 * 1024 * 1024;

/** Human-readable max file size for error messages */
export const MAX_FILE_SIZE_DISPLAY = '10MB';

/** Set of allowed extensions for validation (without dots, lowercase) */
export const ALLOWED_EXTENSIONS_SET = new Set(
  ALLOWED_EXTENSIONS.replace(/\./g, '').split(',')
);

/** Human-readable list of allowed extensions for error messages */
export const ALLOWED_EXTENSIONS_DISPLAY = ALLOWED_EXTENSIONS.replace(/\./g, '')
  .split(',')
  .map((e) => e.toUpperCase())
  .sort()
  .join(', ');

/** Extensions that are displayable as images in the browser */
export const IMAGE_EXTENSIONS = new Set([
  'jpg', 'jpeg', 'png', 'gif', 'bmp', 'svg', 'tiff', 'tif', 'webp',
]);
